<template>
  <main>
    <section>
      <div class="bg-white py-5" style="margin-top: 7.5rem;">
        <div class="container">
          <div class="d-flex mb-3">
            <h2 class="border-super-bottom border-danger pb-2 font-cursive pr-2">{{ about.title }}</h2>
          </div>
          <h4 class="mb-3">{{ about.description }}</h4>
          <p class="text-lead mb-5">{{ about.subdescription }}</p>
          <div class="row">
            <div class="col-12 mb-5">
              <h2 class="text-center font-cursive">{{ about.conformados }}</h2>
            </div>
            <div class="col-md-3 mb-4" v-for="(conformado, index) in filtereditem" :key="index">
              <button class="btn btn-outline-primary btn-block rounded-0" :class="dato == index ? 'active' : ''" @click="select(index)">{{ conformado.title }}</button>
            </div>
            <div class="col-md-10 mb-3 text-left" style="height:150px;">
              <p class="text-lead mb-0" v-for="(item,index) in data" :key="index"> {{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <h2 class="text-center mb-5 font-cursive">{{ about.title }}</h2>
        <div class="row">
          <div class="col-12 border-medio-bottom border-danger pb-2 mb-5" v-for="(socio, index) in partners.list" :key="index">
            <h4>{{ socio.name }}</h4>
            <p class="text-lead text-muted">{{ socio.dep }}</p>
            <p class="text-lead mb-3">{{ socio.description }}</p>
            <p class="text-lead mb-3">{{ socio.description2 }}</p>
            <p class="font-weight-bolder">{{ socio.description3 }}</p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import text_en from '../../text/en/about'
import text_es from '../../text/es/about'
export default {
  data(){
    return{
      about: window.lang == 'es' ? text_es.about : text_en.about,
      filtereditem: window.lang == 'es' ? text_es.filtereditem : text_en.filtereditem,
      data: [],
      partners: window.lang == 'es' ? text_es.partners : text_en.partners,
      dato: 0
    }
  },
  mounted(){
    this.select(0)
  },
  methods: {
    select: function(text){
      this.dato = text
      let list = []
      let _this = this
      $.each(_this.filtereditem, function(index, value){
        if(index == text){
          list.push(value.items)
        }
      })
      this.data = list[0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/about.vue